import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, PermissionService } from '@abp/ng.core';

export const redirectIfAuthenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const permissionService = inject(PermissionService);

  if (authService.isAuthenticated) {
    // Koç yetkisi varsa koç paneline yönlendir
    if (permissionService.getGrantedPolicy('Io.Coaches.ManageOwnStudents')) {
      router.navigate(['/coach/dashboard']);
      return false;
    }

    // Admin yetkisi varsa dashboard'a yönlendir
    if (permissionService.getGrantedPolicy('AbpIdentity.Users')) {
      router.navigate(['/dashboard']);
      return false;
    }

    // Öğrenci ise ödevlerime yönlendir
    router.navigate(['/student/my-assignments']);
    return false;
  }

  return true;
};
